// Shared Prompt & Plate event data

export interface PromptAndPlateEvent {
  id: string;
  day: string;
  date: string;
  time: string;
  location: string; // Can be "Singapore", "Amsterdam", "India", etc.
  venue: string;
  status: "upcoming" | "past";
  media?: {
    images: string[];
    videos: string[];
  };
  tags?: string; // API tag field (next_session, following_session, upcoming, past)
}

// API response item interface
export interface ApiEventItem {
  id: number;
  name: string; // Day name
  name2: string; // Location
  content: string; // Date
  content2: string; // Time
  url_slug: string; // Venue
  tags: string; // next_session, following_session, upcoming, past
  image: string | null; // Comma-separated image filenames
  image2: string | null; // Video filename(s)
  display_order: number;
}

// Transform API data to event format
export function transformApiEventToEvent(apiItem: ApiEventItem, getPublicImage: (folder: string, imagePath?: string) => string | null): PromptAndPlateEvent {
  // Determine status based on tags
  let status: "upcoming" | "past" = "upcoming";
  if (apiItem.tags === "past") {
    status = "past";
  } else if (apiItem.tags === "next_session" || apiItem.tags === "following_session" || apiItem.tags === "upcoming") {
    status = "upcoming";
  }

  // Process images/videos
  let media: { images: string[]; videos: string[] } | undefined = undefined;
  if (status === "past" && (apiItem.image || apiItem.image2)) {
    const images: string[] = [];
    const videos: string[] = [];

    // Process images from 'image' field
    if (apiItem.image) {
      const imageFiles = apiItem.image.split(',').map(f => f.trim()).filter(f => f);
      imageFiles.forEach(file => {
        const imageUrl = getPublicImage('frontend-files', file);
        if (imageUrl) {
          images.push(imageUrl);
        }
      });
    }

    // Process videos from 'image2' field
    if (apiItem.image2) {
      const videoFiles = apiItem.image2.split(',').map(f => f.trim()).filter(f => f);
      videoFiles.forEach(file => {
        const videoUrl = getPublicImage('frontend-files', file);
        if (videoUrl) {
          videos.push(videoUrl);
        }
      });
    }

    if (images.length > 0 || videos.length > 0) {
      media = { images, videos };
    }
  }

  return {
    id: String(apiItem.id),
    day: apiItem.name,
    date: apiItem.content,
    time: apiItem.content2,
    location: apiItem.name2,
    venue: apiItem.url_slug,
    status,
    media,
    tags: apiItem.tags
  };
}

export const events: PromptAndPlateEvent[] = [{
  id: "1",
  day: "Friday",
  date: "6 December 2024",
  time: "12:00 PM",
  location: "Singapore",
  venue: "Cross Street Area",
  status: "upcoming"
}, {
  id: "2",
  day: "Friday",
  date: "13 December 2024",
  time: "12:00 PM",
  location: "Amsterdam",
  venue: "De Pijp District",
  status: "upcoming"
}, {
  id: "3",
  day: "Friday",
  date: "22 November 2024",
  time: "12:00 PM",
  location: "Singapore",
  venue: "Tanjong Pagar",
  status: "past",
  media: {
    images: ["https://images.unsplash.com/photo-1511578314322-379afb476865?w=800", "https://images.unsplash.com/photo-1528605105345-5344ea20e269?w=800", "https://images.unsplash.com/photo-1515187029135-18ee286d815b?w=800", "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800"],
    videos: ["https://www.youtube.com/watch?v=dQw4w9WgXcQ"]
  }
}, {
  id: "4",
  day: "Friday",
  date: "15 November 2024",
  time: "12:00 PM",
  location: "Amsterdam",
  venue: "Jordaan Area",
  status: "past",
  media: {
    images: ["https://images.unsplash.com/photo-1556761175-b413da4baf72?w=800", "https://images.unsplash.com/photo-1515187029135-18ee286d815b?w=800"],
    videos: []
  }
}];
